import i18next from 'i18next'

import { ValidateFormService } from 'services/ValidateFormService'
import { OrderKeys } from 'sections/LKSection/modules/OrderModule/data'

import { MIN_PUBLIC_PHOTO } from '../../data'
import { PickPointFilesViewModel } from '../../models/PickPointFilesViewModel'

export class ValidatePickPointFiles extends ValidateFormService {
  validate = (
    filesModel: PickPointFilesViewModel,
    returnType: 'boolean' | 'array' = 'boolean',
    action: 'create' | 'activate' = 'create',
  ) => {
    const errors: string[] = []

    const getKey = (key: string) => `${OrderKeys.filesStep}.validate.${key}`

    if (filesModel.invalidPhotos(action)) {
      errors.push(i18next.t(getKey('invalidPhotos')))
    }
    if (filesModel.invalidPublicPhotos) {
      errors.push(i18next.t(getKey('invalidPublicPhotos'), { count: MIN_PUBLIC_PHOTO }))
    }
    if (action === 'create' && filesModel.btiDocument.url === '') {
      errors.push(i18next.t(getKey('invalidBti')))
    }
    if (action === 'activate' && filesModel.invalidDocuments) {
      errors.push(i18next.t(getKey('invalidDocuments')))
    }
    if (filesModel.invalidVideo) {
      errors.push(i18next.t(getKey('invalidVideo')))
    }
    if (filesModel.invalidVideoCount) {
      errors.push(i18next.t(getKey('invalidVideoCount')))
    }
    if (filesModel.invalidVideoUrl) {
      errors.push(i18next.t(getKey('invalidVideoUrl')))
    }

    return returnType === 'boolean' ? this.hasNotErrors(errors) : errors
  }
}

export const validatePickPointFiles = new ValidatePickPointFiles()
